import Task from "@/domain/task";

export default class Game {
  public id: string;
  public title: string;
  public intro: string;
  public tasks: Task[];
  public logoUrl: string;
  public publicResults: string[];
  public units: "metric" | "imperial";
  public pinInfo: "order" | "score" | "none";
  public multiplePlayersPerTeam: boolean;

  public mapOverlays: {
    imageUrl: string;
    alpha: number;
    bounds: { top: number; right: number; bottom: number; left: number };
  }[];

  public rules: {
    type: "SHOW_TASK_ON_MAP" | "SHOW_TASK_IN_LIST" | "OPEN_TASK" | "SHOW_TASK_ON_PLAYGROUND" | "FINISH";
    taskId: string;
    rule: any;

    listText: string;
    location: { lat: number; lng: number; radius: number };
    playgroundIndex: number;
    position: number[];
  }[];

  public mapTiles: {
    type: "native" | "native-satellite" | "mapbox" | "mapbox-outdoor" | "mapbox-satellite" | "google-satellite" | "google-custom";
    style?: string;
  }[];

  constructor(id: string, data: Partial<Game>) {
    this.id = id;
    this.title = data.title || "";
    this.intro = data.intro || "";
    this.tasks = data.tasks ? data.tasks.map(task => new Task(task.id, task)) : [];
    this.logoUrl = data.logoUrl || "";
    this.publicResults = data.publicResults || [];
    this.pinInfo = data.pinInfo || "score";
    this.mapOverlays = data.mapOverlays || [];
    this.rules = data.rules || [];
    this.units = data.units || "metric";
    this.mapTiles = data.mapTiles || [];
    this.multiplePlayersPerTeam = data.multiplePlayersPerTeam || false;
  }
}
